if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }

      // CUSTOM //
      // User clicks image any of product images, make it the large/main image
      this.elements.viewer.addEventListener("click", (event) => {
        
        if (event.target.matches('.product__media-item')) {
          const productImageUl = this.querySelector('.prov-product-media')
          const mainImgLi = productImageUl.querySelector('li:nth-child(1)')

          mainImgLi.remove()
          const newImgLi = event.target
          const clone = newImgLi.cloneNode(true)
          productImageUl.prepend(clone)
          if (clone.querySelector('.product-custom-print-overlay')) 
            clone.querySelector('.product-custom-print-overlay').classList.remove('product-custom-print-overlay-small')
          
        }
      })
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      // CUSTOM //
      // Set variant main image back to main/large image before variants change happens
      const mainImg = this.elements.viewer.querySelector('.prov-product-media').querySelector('img') || this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);

      if (mainImg.parentElement === activeMedia) return ;
      const allItems = this.elements.viewer.querySelector('.prov-product-media').querySelectorAll('li');
      for (let i = 1; i < allItems.length; i++) {
        const elImg = allItems[i]?.querySelector('img');
        if (elImg !== mainImg && window.getComputedStyle(elImg.parentElement, null).getPropertyValue('display') !== "none") {
          mainImg.setAttribute("src", elImg.getAttribute("src"));
          mainImg.setAttribute("srcset", elImg.getAttribute("srcset"));
          mainImg.setAttribute("alt", elImg.getAttribute("alt"))
          break;
        }
      }      
      
      const productImageUl = this.querySelector('.prov-product-media')
      const mainImgLi = productImageUl.querySelector('li:nth-child(1)')
      mainImgLi.remove()
      const clone = activeMedia.cloneNode(true)
      productImageUl.prepend(clone)
      if (clone.querySelector('.product-custom-print-overlay')) 
        clone.querySelector('.product-custom-print-overlay').classList.remove('product-custom-print-overlay-small')

      
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ top: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.parentElement.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
